import styledNormalize from 'styled-normalize';
import { injectGlobal } from 'styled-components';

export default () => injectGlobal`
  ${styledNormalize}
  html,
  body,
  #root {
    height: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/styles/index.js